import React, { useEffect } from 'react';

import { UseFormReturn } from 'react-hook-form';

import { useAppSelector } from 'prequalificationV2/hooks/useAppSelector';
import { BorrowerRole } from 'enums/BorrowerRole';
import {
  getEmploymentVariableName,
  getIsInitialValueNotNull,
} from 'prequalificationV2/pages/Dashboard/steps/InformationTabs/AdditionalInformationTab/additionalInformation.utils';
import {
  CurrentEmploymentVariable,
  EmploymentStatusInformationInputLabel,
} from 'prequalificationV2/pages/Dashboard/steps/InformationTabs/AdditionalInformationTab/additionalInformation.enums';
import NumberInput from 'components/Inputs/NumberInput';
import { getErrorMessageForRequiredFields } from 'prequalificationV2/utils/stringUtils';
import { getMessageForInvalidFields } from 'prequalificationV2/utils/validationUtils';
import { isValidDateBeforeNow } from 'prequalificationV2/utils/dateUtils';
import { DateFormat } from 'enums/DateFormat';
import styles from 'prequalificationV2/pages/Dashboard/steps/InformationTabs/InformationTabs.module.scss';

const RetiredNonMilitaryInformation = ({
  formMethods,
  borrowerType,
  watcher,
}: {
  formMethods: UseFormReturn<any, any>;
  borrowerType: BorrowerRole;
  watcher: any;
}) => {
  const { variables } = useAppSelector((state) => state.application);
  const applicationVariables = variables!;

  const {
    register,
    clearErrors,
    formState: { errors },
    setValue,
    trigger,
  } = formMethods;

  useEffect(() => {
    register(getEmploymentVariableName(CurrentEmploymentVariable.RetirementDate, borrowerType), {
      required: {
        value: !watcher[getEmploymentVariableName(CurrentEmploymentVariable.RetirementDate, borrowerType)],
        message: getErrorMessageForRequiredFields(EmploymentStatusInformationInputLabel.RetirementDate),
      },
      validate: (value) => {
        return (
          isValidDateBeforeNow(value, DateFormat.MonthYear) ||
          getMessageForInvalidFields(EmploymentStatusInformationInputLabel.RetirementDate)
        );
      },
    });
  }, []);

  return (
    <div className={styles.formRow}>
      <NumberInput
        label={EmploymentStatusInformationInputLabel.RetirementDate}
        name={getEmploymentVariableName(CurrentEmploymentVariable.RetirementDate, borrowerType)}
        value={watcher[getEmploymentVariableName(CurrentEmploymentVariable.RetirementDate, borrowerType)]}
        errorMessage={
          errors[getEmploymentVariableName(CurrentEmploymentVariable.RetirementDate, borrowerType)]?.message
        }
        className={styles.input}
        onChange={(event) => {
          clearErrors(getEmploymentVariableName(CurrentEmploymentVariable.RetirementDate, borrowerType));
          setValue(
            getEmploymentVariableName(CurrentEmploymentVariable.RetirementDate, borrowerType),
            event.target.value,
          );
        }}
        onBlur={() => {
          if (watcher[getEmploymentVariableName(CurrentEmploymentVariable.RetirementDate, borrowerType)]) {
            trigger(getEmploymentVariableName(CurrentEmploymentVariable.RetirementDate, borrowerType));
          }
        }}
        placeholder="MM/YYYY"
        format="##/####"
        mask="_"
        allowEmptyFormatting
        disabled={getIsInitialValueNotNull(
          applicationVariables[getEmploymentVariableName(CurrentEmploymentVariable.RetirementDate, borrowerType)],
        )}
      />
    </div>
  );
};

export default RetiredNonMilitaryInformation;
